module.exports = __webpack_public_path__ + "logo.f21b561185c7f2c3fc87.png";


//////////////////
// WEBPACK FOOTER
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/assets/images/logo.png
// module id = ../../../../../src/assets/images/logo.png
// module chunks = styles